// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AccountBookFilledSvg from "@fishx/icons-svg/es/asn/AccountBookFilled";
import FishxIcon from '../components/FishxIcon';

var AccountBookFilled = function AccountBookFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AccountBookFilledSvg
  }));
};

AccountBookFilled.displayName = 'AccountBookFilled';
export default React.forwardRef(AccountBookFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AccountBookFilled.js
// module id = 1941
// module chunks = 0